import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/modules/shared-area/root-state';

const sharedState = (state: IAppState) => state.shared;
const merkmalState = createSelector(sharedState, state => state.merkmale);

export const getLastSelectedMerkmal = createSelector(merkmalState, state => state.lastSelectedMerkmal);
export const getMerkmale = createSelector(merkmalState, state => state.merkmaleTree);
